import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { Link, Title, TitleIcon, TitleWrapper, Wrapper } from "./Styles";

NewFeatures.propTypes = {
  show: PropTypes.bool,
};

export default function NewFeatures({ show }) {
  if (!show) return null;

  return (
    <StyledWrapper>
      <TitleWrapper>
        <TitleIcon>
          <i className="fad fa-gift" />
        </TitleIcon>
        <TitleCustom>New features just for you!</TitleCustom>
      </TitleWrapper>

      <LinkCustom
        href="https://flocknote.com/feature-updates/"
        target="_blank"
        rel="noreferrer"
      >
        See our growing list of new features&nbsp;&gt;
      </LinkCustom>
    </StyledWrapper>
  );
}

const StyledWrapper = styled(Wrapper)`
  background-color: none;
  box-shadow: none;
`;

const TitleCustom = styled(Title)`
  line-height: 1;
`;

const LinkCustom = styled(Link)`
  margin-top: 0;
  font-size: 14px;
`;
